module.exports = "/images/arena-01.png?cd988b31dbe9ed9487e814d95a746373";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/arena-01.png
// module id = IjC7
// module chunks = 0